module.exports = fox._r("fonts/ostrich-sans-black.eot", __webpack_public_path__ + "_/_/_/root/fonts/3EiCKp0.eot");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/ostrich-sans-black.eot
// module id = 171
// module chunks = 4